import { render, staticRenderFns } from "./WorkflowMove.vue?vue&type=template&id=1b27b1e6&scoped=true"
import script from "./WorkflowMove.vue?vue&type=script&lang=js"
export * from "./WorkflowMove.vue?vue&type=script&lang=js"
import style0 from "./WorkflowMove.vue?vue&type=style&index=0&id=1b27b1e6&prod&lang=less"
import style1 from "./WorkflowMove.vue?vue&type=style&index=1&id=1b27b1e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b27b1e6",
  null
  
)

export default component.exports